const React = require("react");
require("./src/pages/common.scss");
const { Provider } = require("react-redux");
const { rootReducer } = require("./src/Store/Reducer/Reducer");
const { createStore } = require("redux");
const { getCookieData } = require("./src/Store/GetData");
const { navigate } = require("gatsby");
const { Sessionstore } = require("./src/Store/StoreData");
const { captureAndSendAdsData, ensureCalendar } = require('./src/services/utility');

const store = createStore(rootReducer);

exports.wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};

exports.wrapPageElement = ({ element }) => {
  return (
    <div className="page-transition">
      {element}
    </div>
  )
};

exports.onRouteUpdate = ({ prevLocation }) => {
  // The deferred /campaign-track.js script handles the first full page load.
  // Client-side moves (home -> /tryit-forfree, or a new gclid) ask it again.
  // It reuses the stored Ref and does not open another tracking row.
  try {
    if (prevLocation) captureAndSendAdsData();
  } catch (e) {
    console.error('[Tracking] onRouteUpdate capture failed', e);
  }

  if (!prevLocation) return;
  const el = document.querySelector('.page-transition')
  if (el) {
    el.style.opacity = '0'
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = 'opacity 0.3s ease-out'
        el.style.opacity = '1'
      })
    })
  }
};

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location;
  const scrollToTopRoutes = [
    `/ourstory/advisor`,
    `/ourstory/enabler`,
    `/ourstory/doers`,
  ];
  if (!scrollToTopRoutes.includes(pathname)) {
    window.scrollTo(0, 0);
  }
  return false;
};

/* global Cal, gtag, ga, fbq */
exports.onClientEntry = () => {
  // Capture feedback token from URL before it gets stripped
  try {
    const params = new URLSearchParams(window.location.search);
    const feedbackToken = params.get('token');
    if (window.location.pathname.includes('/demo-feedback') && feedbackToken) {
      sessionStorage.setItem('feedbackToken', feedbackToken);
    }
  } catch (e) {
    console.error("Error capturing feedback token:", e);
  }

  // /campaign-track.js runs from the head. If it never booted, capture
  // once the page is loaded so a paid landing is still recorded.
  window.addEventListener('load', () => {
    if (window.__ableauraLandingTrackBooted || window.__ableauraWaBooted) return;
    captureAndSendAdsData();
  });

  // Cal.com loads on the first Schedule a Call click, not with the page.
  // Other data-cal-link buttons (sports pages) take the same path so the
  // first tap still opens the modal after the embed script arrives.
  if (window.location.pathname.includes('/demo-feedback')) return;

  document.addEventListener('click', (event) => {
    const target = event.target;
    const el = target && target.closest ? target.closest('[data-cal-link]') : null;
    if (!el || window.__ableauraCalReady) return;
    event.preventDefault();
    event.stopPropagation();
    let config = { layout: 'month_view' };
    try {
      const raw = el.getAttribute('data-cal-config');
      if (raw) config = JSON.parse(raw);
    } catch (e) {
      config = { layout: 'month_view' };
    }
    const calLink = el.getAttribute('data-cal-link');
    const calOrigin = el.getAttribute('data-cal-origin') || 'https://bookings.academy.ableaura.com';
    ensureCalendar().then((cal) => {
      if (!cal || !calLink) return;
      cal('modal', { calLink, calOrigin, config });
    }).catch(() => {});
  }, true);
};



